import { DestinationState } from 'components/search/bex/interfaces';

const initialDestinationState: DestinationState = {
  destination: '',
};

export { initialDestinationState };
